import { generateID } from 'app/utils/functions';
import { colors } from 'app/utils/colors';

const tag = {
  namespaced: true,
  state: {
    tags: [
      {
        name: 'All',
        id: 1,
        color: colors[17],
      },
      {
        name: 'Friends',
        id: 2,
        color: colors[0],
      },
      {
        name: 'Fun',
        id: 3,
        color: colors[0],
      },
      {
        name: 'Facebook',
        id: 4,
        color: colors[0],
      },
      {
        name: 'GIFs',
        id: 5,
        color: colors[0],
      },
    ],
    selectedTagId: 1,
  },
  mutations: {
    selectTag(state, id) {
      if (state.tags.length == 0) {
        state.selectedTagId = null;
      } else {
        state.selectedTagId = id;
      }
    },
    editTag(state, tag) {
      tag = { ...tag };
      for (let i = 0; i < state.tags.length; i++) {
        if (state.tags[i].id == tag.id) {
          // state.tags[i].name = tag.name;
          for (let key in state.tags[i]) {
            state.tags[i][key] = tag[key];
          }
          break;
        }
      }
    },
    addTag(state, tag) {
      tag.id = generateID();
      if (state.tags.length == 0) {
        state.selectedTagId = tag.id;
      }
      state.tags.push({ ...tag });
    },
    deleteTag(state, id) {
      for (let i = 0; i < state.tags.length; i++) {
        if (state.tags[i].id == id) {
          state.tags.splice(i, 1);
          if (state.selectedTagId == id) {
            if (state.tags.length == 0) {
              state.selectedTagId = null;
            } else {
              state.selectedTagId = state.tags[0].id;
            }
          }
          break;
        }
      }
    },
  },
  actions: {
    selectTag(context, payload) {
      context.commit('selectTag', payload);
    },
    editTag(context, tag) {
      context.commit('editTag', tag);
    },
    addTag(context, tag) {
      context.commit('addTag', tag);
    },
    deleteTag(context, id) {
      context.commit('deleteTag', id);
    },
  },

  getters: {
    tags: state => {
      return state.tags.filter(t => t.id != 1);
    },
    allTags: state => {
      return state.tags;
    },
    selectedTagId: state => {
      return state.selectedTagId;
    },
    selectedTag: state => {
      return state.tags.find(t => t.id == state.selectedTagId);
    },
  },
};

export { tag };
